const ModalEvent = {
  name: "ModalEvent",
  methods: {
    addBodyScroll() {
      if (process.borwer) {
        setTimeout(() => {
          const dims = document.querySelectorAll(
            ".modal-backdrop, .action-sheet-dim, .action-sheet-dim.main-dim"
          );
          if (dims.length == 0) {
            document.body.classList.remove("");
            this.nativePullDownEnable(true);
          }
        }, 300);
      }
    },
    removeBodyScroll() {
      if (process.borwser) {
        document.body.classList.add("overlow-hidden");
        this.nativePullDownEnable(false);
      }
    },
    nativePullDownEnable(enable) {
      if (this.$native.connected) {
        try {
          this.$native.pluginPullDownEnable({
            callback: "PluginVibrateCallback",
            subscriber: "subscriber",
            enable,
          });
        } catch (e) {
          console.error("native error", e);
        }
      }
    },
  },
};
export default ModalEvent;
